import { AbsRemixPage } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { Loading } from '~/components/loading';
import { $LegalCurrentTraffic } from 'shared/atoms';

import './style.scss';

export abstract class LegalRemixPage extends AbsRemixPage {
  HeadSkeleton = () => {
    return (
      <>
        <title>Lemon8 Loading...</title>
      </>
    );
  };
  BodySkeleton = () => {
    return (
      <div className="full-screen-layout">
        <Loading variant="ball" />
      </div>
    );
  };

  useRouteLoading = () => {
    const { href } = useAtomValue($LegalCurrentTraffic);

    if (__BUILD_TARGET__ === 'server') {
      return false;
    }

    const a = new URL(href);
    return location.pathname !== a.pathname;
  };
}
